import { useEffect, useMemo, useRef } from "react";
import log from "logbeacon";
import { cn } from "utils";
import { AgentTextClassMap } from "../../const";
import { TAAgentProps } from "./types";
import Translations from "@translate/components/CoPilot/CopilotAgent/TAAgent/TAAgent";
import { I18nUtil } from "@utils/i18n";
import { TATimelineRef, TATimeline } from "@/src/components/PortfolioTimeline";
import { useAgentReportList, useIsPc } from "@/src/hooks";
import { AgentReport } from "@/src/features/api/memberApi";
import { formatDateGroup, groupByDate } from "@/src/utils";
import NextImage from "@/src/components/NextImage";

const I18n = I18nUtil.createScoped(Translations);

export const TAAgent = (props: TAAgentProps) => {
  const { agentId, onChartClick } = props;
  const timelineRef = useRef<TATimelineRef>(null);
  const [isPC] = useIsPc();
  const {
    data,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    error,
  } = useAgentReportList({
    params: {
      agent_ids: agentId.split(",") as string[],
    },
  });

  useEffect(() => {
    log.debug("[TAAgent] data", data);
  }, [data]);

  const groupedData = useMemo(() => {
    return groupByDate<AgentReport>(
      data,
      "created",
      "YYYY-MM-DD",
      formatDateGroup,
    );
  }, [data]);

  return (
    <div
      className="w-full h-screen flex flex-col overflow-hidden "
      data-tracking-scope="ta-timeline-example"
    >
      {isPC && (
        <div className="flex items-center gap-1">
          <NextImage
            src="/assets/images/agent-tip.svg"
            alt="agent-tip"
            width={20}
            height={20}
          />
          <p className={cn("body_bold_l", AgentTextClassMap.default)}>
            {I18n.t("Technical Signals For You")}
          </p>
        </div>
      )}
      {/* 时间线 */}
      <div className="flex-1 min-h-0 mt-4" data-tracking-scope="ta-timeline">
        <TATimeline
          ref={timelineRef}
          initialData={groupedData}
          hasNextPage={hasNextPage}
          onLoadMore={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
          isLoading={isLoading}
          stickyTopOffset={0} // 考虑顶部控制按钮的高度
          className="h-full"
          onChartClick={onChartClick}
          isFetching={isFetching}
          error={error ?? (undefined as Error | undefined)}
          data={data}
        />
      </div>
    </div>
  );
};
